import { render, staticRenderFns } from "./WaterScroll.vue?vue&type=template&id=32377b40&scoped=true"
import script from "./WaterScroll.vue?vue&type=script&lang=js"
export * from "./WaterScroll.vue?vue&type=script&lang=js"
import style0 from "./WaterScroll.vue?vue&type=style&index=0&id=32377b40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32377b40",
  null
  
)

export default component.exports